import React from 'react'
import { EyeIcon } from '@heroicons/react/24/solid'

const ObjectIsPublic = ({ object }) => {
  const color = object.isPublic ? 'green' : 'red'

  return (
    <div
      className={`bg-${color}-100 border border-${color}-300 my-auto flex h-9 space-x-2 rounded-md px-3`}
    >
      <span className="flex flex-col justify-center">
        <EyeIcon className={`h-5 w-5 text-${color}-500`} />
      </span>
      <div
        className={`hidden flex-col justify-center text-${color}-900 md:flex`}
      >
        <span>{object.isPublic ? 'Public' : 'Private'}</span>
      </div>
    </div>
  )
}

export default ObjectIsPublic
